import React from 'react';
import SignUpForm from './SignUpForm';
import { Link } from 'react-router-dom';

const SignUpPage: React.FC = () => {
  return (
    <div className="w-full min-h-screen bg-slate-50">
      {/* Header */}
      <div className="w-full h-20 bg-white shadow-[0px_4px_4px_0px_rgba(0,0,0,0.01)]">
        <div className="max-w-[1920px] mx-auto px-4 h-full relative flex items-center">
          <Link to="/" className="md:block hidden">
            <div className="w-auto h-8 left-[40px] top-[26px] absolute whitespace-nowrap text-[#1A253F] text-[14px] md:text-[28px] font-extrabold font-pretendard leading-9">
              부산항신항시설관리센터
            </div>
          </Link>
          {/* Mobile Header */}
          <Link to="/" className="md:hidden block w-full">
            <div className="w-full h-7 text-center text-[#1A253F] text-[18px] md:text-[28px] font-extrabold font-pretendard leading-9">
              부산항신항시설관리센터
            </div>
          </Link>
        </div>
      </div>
      <div className="w-full h-px bg-white border border-slate-200"></div>

      {/* Main Content */}
      <div className="max-w-[1920px] mx-auto px-4 py-6 md:py-12">
        <div className="w-[calc(100%-32px)] md:w-[688px] mx-auto bg-white rounded-sm outline outline-1 md:outline-1 outline-slate-200">
          <div className="px-4 md:px-[74px] py-8 md:py-[60px]">
            <div className="w-full md:w-64 h-11 justify-center text-slate-800 text-2xl md:text-4xl font-extrabold font-['Pretendard'] leading-9">
              계정 만들기
            </div>
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between mt-4 gap-2 md:gap-0">
              <div className="text-slate-700 text-sm md:text-base font-normal font-['Pretendard'] leading-relaxed">
                이미 계정이 있으신가요?
              </div>
              <button
                onClick={() => window.location.href = '/signin'}
                className="text-blue-500 text-sm md:text-base font-medium font-['Pretendard'] underline leading-relaxed"
              >
                로그인하기
              </button>
            </div>
            
            <SignUpForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUpPage; 